import { render, staticRenderFns } from "./TouchpointStatisticsOther.vue?vue&type=template&id=59107ada&scoped=true&"
import script from "./TouchpointStatisticsOther.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsOther.vue?vue&type=script&lang=js&"
import style0 from "../../../../Style/touchpoint-statistics.scss?vue&type=style&index=0&id=59107ada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59107ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59107ada')) {
      api.createRecord('59107ada', component.options)
    } else {
      api.reload('59107ada', component.options)
    }
    module.hot.accept("./TouchpointStatisticsOther.vue?vue&type=template&id=59107ada&scoped=true&", function () {
      api.rerender('59107ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/TouchpointStatisticsOther.vue"
export default component.exports